import {Pipe, PipeTransform, SecurityContext} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';

/**
 * Sanitizes rather than blindly trusting HTML (BRIEFD-6798). The values
 * passed through this pipe are tenant-entered content (rich-text fields,
 * dynamic form labels) or external-API content (blog feed) - never fully
 * trusted input - so this must strip dangerous tags/attributes (script,
 * event handlers, javascript: URLs) while still allowing safe formatting
 * (bold, links, lists, etc.) to render.
 */
@Pipe({
    name: 'safeHtml',
    standalone: false
})
export class SafeHtmlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {
  }

  transform(value: string): string {
    return this.sanitizer.sanitize(SecurityContext.HTML, value) ?? '';
  }
}
